/* ***************************************************
 アコーディオン
*************************************************** */
$('.accordion-header').click(function () {
  $(this).next().slideToggle();
  $(this).toggleClass('active');
});

/* ***************************************************
 splide
*************************************************** */
document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('.splide',  {
    autoplay: false, // 自動再生
    type: "loop", // ループ
    pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
    pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
    perPage: 1,
    perMove: 1,
    focus: 0,
    interval: 3000, // 自動再生の間隔
    speed: 1500, // スライダーの移動時間
    padding: "10%", // スライダーの左右の余白
    gap: 20, // スライド間の余白
  }).mount();
});